const emptyModel = {
  title: '',
  description: '',
  client_id: null,
  fader_settings: {
    fade_in_duration: null,
    fade_out_duration: null,
    fade_shift_duration: null
  }
}

const emptyFilters = {
  client_id: undefined,
  name: ''
}

export default {
  emptyModel,
  emptyFilters
}
